export const selectCategories = (reduxState) => reduxState.gamePage.categories;
export const selectQuestions = (reduxState) => reduxState.gamePage.questions;
